export const ar = {
  // Navigation
  nav: {
    home: "الرئيسية",
    about: "نبذة عني",
    skills: "المهارات",
    projects: "المشاريع",
    experience: "الخبرة",
    contact: "اتصل بي",
    portfolio: "الملف الشخصي",
    light: "فاتح",
    dark: "داكن",
    english: "الإنجليزية",
    arabic: "العربية",
    french: "الفرنسية",
  },

  loading: {
    message: "جاري تحميل الملف الشخصي…",
  },

  // Hero Section
  hero: {
    title: "مخلص العاجيمي",
    eyebrow: "مرحباً، أنا",
    subtitle: "مطور تطبيقات ويب وموبايل متكامل",
    availableBadge: "متاح للعمل الحر",
    recentLaunches: "إطلاقات حديثة",
    metricYears: "سنوات خبرة",
    metricProjects: "مشاريع",
    metricStores: "Play & App Store",
    description:
      "مطور تطبيقات موبايل متكامل مع أكثر من 5 سنوات في بناء تطبيقات Flutter عالية الأداء وخوادم قابلة للتوسع. أركز على تجربة مستخدم سلسة وتدفقات بيانات موثوقة وتسليم جاهز للإنتاج عبر Android و iOS والويب.",

    downloadCV: "تحميل السيرة الذاتية",
    contactWhatsApp: "تواصل عبر واتساب",
  },

  // About Section
  about: {
    title: "نبذة عني",
    description1:
      "أنا مطور شغوف مع أكثر من 5 سنوات من الخبرة في إنشاء حلول رقمية تحدث فرقاً. أتخصص في تقنيات الويب الحديثة وأحب تحويل المشاكل المعقدة إلى تصاميم بسيطة وجميلة.",
    description2:
      "عندما لا أكون أكتب الكود، يمكنك أن تجدني أستكشف التقنيات الجديدة، أساهم في المشاريع مفتوحة المصدر، أو أشارك معرفتي مع مجتمع المطورين.",
    stats: [
      { number: "50+", label: "المشاريع المكتملة" },
      { number: "5+", label: "سنوات الخبرة" },
      { number: "100%", label: "رضا العملاء" },
    ],
  },

  // Skills Section
  skills: {
    title: "المهارات",
    subtitle: "أدواتي اليومية",
    technologies: "تقنية",
    yearsExperience: "سنوات خبرة",
    projectsBuilt: "مشروع مبني",
    mobileDevelopment: "تطوير التطبيقات",
    mobileDescription: "حلول موبايل متعددة المنصات",
    frontendDevelopment: "تطوير الواجهات",
    frontendDescription: "واجهات ويب حديثة",
    backendDevelopment: "تطوير الخوادم",
    backendDescription: "حلول خوادم قوية",
    dataCloud: "البيانات والسحابة",
    dataCloudDescription: "حلول بيانات قابلة للتوسع",
    additionalExpertise: "خبرات إضافية",
    additionalSubtitle: "",
  },

  // Projects Section
  projects: {
    title: "المشاريع",
    subtitle: "منتجات على Play Store وApp Store والويب",
    countLabel: "مشاريع",
    seeMore: "عرض المزيد",
    seeLess: "عرض أقل",
    clickServices: {
      title: "Click Services",
      description:
        "سوق خدمات متعدد اللغات (15+ لغة): دردشة فورية، حجوزات، محفظة وخصم نقدي، مدفوعات آمنة.",
    },
    ritchess: {
      title: "Ritchess",
      description:
        "مجموعة حجز الرحلات (عميل، سائق، إدارة): حجز، تتبع مباشر، تقييمات، مناطق، مدفوعات، إشعارات.",
    },
    spr01: {
      title: "SPR01 & leFri9i Club",
      description:
        "تطبيق إدارة أكاديمية ونادي رياضي: حضور، اختبارات، أحداث، أخبار، ملفات أولياء الأمور/الأطفال، أدوات إدارة.",
    },
    convergeImmob: {
      title: "Converge Immob",
      description:
        "تطبيق عقارات مع تقدير ذكي، وسائط 360 درجة، مرشحات متقدمة، مصادقة، مفضلة، حجز زيارات، مستويات مميزة.",
    },
    sfaxOutdoor: {
      title: "Sfax Outdoor Sports (Trekna)",
      description:
        "تطبيق الرياضات البيئية والطبيعة: دوائر (VTT/راندو)، حجوزات، وتتبع الخريطة.",
    },
    puzzleSwap: {
      title: "Puzzle Swap Game",
      description:
        "لعبة ألغاز تبادل صديقة للعائلة. تحديات مؤقت، واجهة مستخدم متجاوبة، تعمل على الويب والموبايل.",
    },
    playStore: "متجر Play",
    appStore: "متجر التطبيقات",
    clientPlay: "العميل (Play)",
    driverPlay: "السائق (Play)",
    clientIOS: "العميل (iOS)",
    driverIOS: "السائق (iOS)",
    spr01Play: "SPR01 (Play)",
    spr01IOS: "SPR01 (iOS)",
    leFri9iPlay: "leFri9i (Play)",
    leFri9iIOS: "leFri9i (iOS)",
    requestDemo: "طلب عرض توضيحي",
    playOnline: "العب عبر الإنترنت",
  },

  // Experience Section
  experience: {
    title: "الخبرة",
    subtitle: "نمو وملكية وتأثير عبر الموبايل والويب",
    items: [
      {
        period: "09/2025 - Present",
        title: "مطور Flutter موبايل",
        company: "NexBuild, Tunisie",
        description:
          "قيادة تسليم تطبيقات موبايل متعددة المنصات مع Flutter، من تنفيذ UI/UX وفق التصاميم إلى الإصدارات على Google Play وApp Store. المشاركة في تخطيط المشاريع والمواصفات التقنية، ودمج APIs موثوقة ومختبرة (Postman، Swagger).",
      },
      {
        period: "01/2024 - 09/2025",
        title: "مطور Flutter أول · ويب متكامل",
        company: "Converge Innova, Tunisie",
        description:
          "قيادة تطوير تطبيقات متعددة المنصات مع Flutter؛ تصميم خوادم Node.js/MongoDB؛ CI/CD والمراقبة؛ اختبار API مع Postman/Swagger؛ تعاون Agile Scrum؛ تسليم وصيانة العملاء.",
      },
      {
        period: "02/2022 – 01/2024",
        title: "مطور Flutter وخوادم",
        company: "3D Wave Sousse, Tunisie",
        description:
          "نشر تطبيقات Android/iOS؛ بناء خدمات REST/GraphQL (Node.js/Flask)؛ امتلاك الميزات من البداية للنهاية؛ العمل في فرق Agile؛ صيانة أنظمة الإنتاج.",
      },
      {
        period: "02/2021 – 11/2023",
        title: "مطور Full Stack",
        company: "Lonch (FreeLance)",
        description:
          "امتلك لوحات تحكم Retool للعمليات؛ بناء إضافات داخلية مع Flutter؛ دمج مصادر البيانات وأتمت سير العمل؛ تعاون مع أصحاب المصلحة للتكرار على الأدوات وعمليات الإطلاق.",
      },
    ],
  },

  // Contact Section
  contact: {
    title: "لنتحدث",
    subtitle: "فكرة؟ أساعدك على إطلاقها.",
    methodWhatsApp: "رد سريع",
    methodEmail: "بريد",
    methodLinkedIn: "لينكد إن",
    methods: [
      {
        name: "WhatsApp",
        url: "https://wa.me/21629060392",
        icon: "fab fa-whatsapp",
      },
      {
        name: "Email",
        url: "mailto:mokhleslajimi@gmail.com",
        icon: "fas fa-envelope",
      },
      {
        name: "LinkedIn",
        url: "https://www.linkedin.com/in/mokhleslajimi/",
        icon: "fab fa-linkedin",
      },
    ],
    form: {
      fields: [
        { label: "اسمك", placeholder: "محمد العاجيمي" },
        { label: "البريد", placeholder: "you@example.com" },
        { label: "الشركة (اختياري)", placeholder: "Acme" },
        {
          label: "تفاصيل المشروع",
          placeholder: "ماذا تبني؟ المنصات والجدول…",
        },
      ],
      hint: "رد خلال 24–48 ساعة.",
      submitText: "إرسال",
    },
  },

  // Footer
  footer: {
    description:
      "مطور موبايل وويب متكامل — منتجات حقيقية في الإنتاج.",
    quickLinks: "روابط سريعة",
    services: "الخدمات",
    quickLinksTitle: "روابط سريعة",
    servicesTitle: "الخدمات",
    mobileAppDev: "تطوير تطبيقات الموبايل",
    webDev: "تطوير الويب",
    backendDev: "تطوير الخوادم",
    uiUxConsulting: "استشارات UI/UX",
    technicalConsulting: "استشارات تقنية",
    downloadCV: "تحميل السيرة الذاتية",
    allRightsReserved: "جميع الحقوق محفوظة.",
  },
};
